<template>
  <div>
    <please-wait class="mt-6" v-if="isLoading"></please-wait>
    <v-card
      flat
      style="max-width: 800px; margin: 0 auto"
      class="pa-md-5 pa-3 mt-6"
      v-if="job.id"
    >
      <div class="title mb-3">Job Details</div>
      <div class="subtitle-2 grey--text" v-html="text"></div>
      <div class="d-flex mt-3">
        <primary-button class="success mr-3" @click="acceptJob(true)"
          >Accept</primary-button
        >
        <error-button @click="acceptJob(false)">Reject</error-button>
      </div>
    </v-card>
  </div>
</template>

<script>
import customerModal from "../assets/js/customer.modal";
import { FIELD } from "../assets/js/rules";
import PleaseWait from "../components/PleaseWait.vue";
import { functions } from "../assets/js/firebase";
import PrimaryButton from "../components/ui/btns/PrimaryButton.vue";
import ErrorButton from "../components/ui/btns/ErrorButton.vue";
export default {
  components: {
    PleaseWait,
    PrimaryButton,
    ErrorButton,
  },
  data() {
    return {
      rules: FIELD,
      isLoading: true,
      job: {},
      text: "",
      fields: [],
      loading: false,
    };
  },
  computed: {
    isJobCompleted() {
      return this.form.disposition == customerModal.DISPOSITION_COMPLETE;
    },
    isJobCancelled() {
      return this.form.disposition == customerModal.DISPOSITION_CANCEL;
    },
    jobStatus() {
      return [
        {
          name: "Completed",
          value: customerModal.DISPOSITION_COMPLETE,
        },
        {
          name: "Cancelled",
          value: customerModal.DISPOSITION_CANCEL,
        },
      ];
    },
    howPaidOptions() {
      let field = this.fields.find((i) => i.id == customerModal.HOW_PAID);
      return field ? field.options : [];
    },
    reasonOptions() {
      let field = this.fields.find(
        (i) => i.id == customerModal.REASON_FOR_CANCELLATION
      );
      return field ? field.options : [];
    },
  },
  methods: {
    onStatusChange() {
      this.form.how_paid = "";
      this.form.reason = "";
    },
    async acceptJob(isAccept) {
      const vm = this;
      try {
        vm.$loader.show();
        let closeOutJob = functions.httpsCallable("manageJob");
        let reference = vm.$route.params.id;
        let { status, message } = (await closeOutJob({ reference, isAccept }))
          .data;
        vm.$loader.hide();
        if (status) {
          vm.job = {};
          if (isAccept) {
            vm.$alert.show("Job is accepted successfully.");
          } else {
            vm.$alert.show("Job is rejected successfully");
          }
        } else {
          vm.$alert.show(message);
        }
      } catch (error) {
        vm.$alert.show(error.message);
        vm.$loader.hide();
      }
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    async getJobDetails() {
      const vm = this;
      try {
        vm.isLoading = true;
        let getJobDetails = functions.httpsCallable("getCloseOutJob");
        let reference = vm.$route.params.id;
        let { status, message, result } = (
          await getJobDetails({ reference, isJobAccept: true })
        ).data;
        vm.isLoading = false;
        if (status) {
          vm.job = result.customerDoc;
          vm.fields = result.fields;
          vm.text = result.text.split("\n").join("<br/>");
        } else {
          vm.$alert.show(message);
        }
      } catch (error) {
        vm.$alert.show(error.message);
        vm.isLoading = false;
      }
    },
  },
  mounted() {
    this.getJobDetails();
  },
};
</script>

<style>
</style>